import API from '@/shared/plugins/Api/API'

class RepositoryV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  _tagUrl (appName, tagName) {
    return `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}`
  }

  async get (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/repository/config`
    })
    return response
  }

  async update (appName, body) {
    const response = await this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/repository/config`,
      data: body
    })
    return response
  }

  async patch (appName, body) {
    const response = await this.request({
      method: 'patch',
      url: `${this._appUrl(appName)}/repository/config`,
      data: body
    })
    return response
  }

  async delete (appName) {
    await this.request({
      method: 'delete',
      url: `${this._appUrl(appName)}/repository/config`
    })
  }

  // Pass `url` to preview a candidate repository before saving it;
  // omit it to list branches of the configured repository.
  async branches (appName, { url } = {}) {
    const params = {}
    if (url) params.url = url
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/repository/branches`,
      params
    })
    return response
  }

  // Async on the API side (202): progress is streamed via WebSocket.
  // `body` may carry a { credentials: { user, password } } override.
  async pull (appName, tagName, body) {
    const response = await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/repository/pull`,
      data: body
    })
    return response
  }

  async push (appName, tagName, body) {
    const response = await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/repository/push`,
      data: body
    })
    return response
  }
}

export default RepositoryV3
